import React from "react"
import { Grid } from "@material-ui/core"
import { Stars as StarsIcon, Edit as EditIcon } from "@material-ui/icons"
import ActionDialog from "@/components/ActionDialog"
import TemplateMethodCard from "@/pages/Admin/Templates/components/TemplateMethodCard"
import { externalLinks } from "@/utils/link"
import { useHistory } from "react-router-dom"

type TemplateCreationDialogProps = {
	isOpen: boolean
	onClose: () => void
	userName: string
	userEmail: string
	userPhone: string | undefined
}

const TemplateCreationDialog: React.FC<TemplateCreationDialogProps> = ({ isOpen, onClose, userName, userEmail, userPhone }) => {
	const history = useHistory()

	const buildGeneratorURL = () => {
		const url = new URL(externalLinks.generatorTemplates)

		const generatorParamToValue: Record<string, string | undefined> = {
			userName,
			userEmail,
			phone: userPhone
		}

		for (const [param, value] of Object.entries(generatorParamToValue)) {
			if (value) url.searchParams.set(param, value)
		}

		return url.toString()
	}

	const handleSelectAutomatic = () => {
		window.open(buildGeneratorURL(), "_blank")
		onClose()
	}

	const handleSelectManual = () => {
		history.push("/admin/template/manage")
	}

	return (
		<ActionDialog
			title="Adicionar Template"
			openDialog={isOpen}
			onClose={onClose}
			hideCloseButton
			maxWidth="sm"
			fullWidth
		>
			<Grid container spacing={2}>
				<Grid item xs={12} sm={6}>
					<TemplateMethodCard
						icon={<StarsIcon />}
						title="Gerador de Templates"
						description="Crie templates de forma guiada pelo nosso gerador externo com IA."
						onClick={handleSelectAutomatic}
						pulse
					/>
				</Grid>

				<Grid item xs={12} sm={6}>
					<TemplateMethodCard
						icon={<EditIcon />}
						title="Criar do Zero"
						description="Preencha os campos diretamente na plataforma e configure seu template do zero."
						onClick={handleSelectManual}
					/>
				</Grid>
			</Grid>
		</ActionDialog>
	)
}

export default TemplateCreationDialog
